<template>
  <ul class="flex flex-col space-y-12 m-0 app-list text-start">
    <li
      v-for="(data, dataIndex) in data"
      :key="dataIndex"
      class="flex flex-col md:flex-row gap-x-6 gap-y-2 md:items-start text-gray-dark"
    >
      <div class="rounded-full h-20 w-full max-w-6 max-h-6 md:max-h-8 md:max-w-8 bg-secondary flex items-center justify-center text-white mt-1.5 ">
        <span class="absolute bg-secondary">
          {{ dataIndex + 1 }}
        </span>
      </div>

      <div>
        <h3 class="font-medium mb-1">
          {{ data.title }}
        </h3>

        <ul>
          <li
            v-for="content in processContent(data)"
            class="mb-0"
            :class="Array.isArray(data.content) ? 'ml-5' : 'list-none'"
          >
            <span
              v-for="(part, index) in content"
              :key="index"
            >
              <strong
                v-if="part.bold"
                class="text-black font-medium"
              >
                {{ part.text }}
              </strong>

              <span v-else>{{ part.text }}</span>
            </span>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  data: Array,
});

const processContent = (data) => {
  let contents = Array.isArray(data.content) ? data.content : [data.content];

  const boldWords = Array.isArray(data.boldWords) ? data.boldWords : [];
  const regex = new RegExp(`(${boldWords.join('|')})`, 'gi');

  return contents.map(text => {
    const parts = text.split(regex);
    return parts.map(part => ({
      text: part,
      bold: boldWords.some(word => word.toLowerCase() === part.toLowerCase().trim()),
    }));
  });
};
</script>
